import * as React from 'react';
import unsuccessImg from './orange-small-cross.png';
export const Unsuccess = ({ message }) => (React.createElement("div", { className: "unsus-msg" },
    React.createElement("img", { src: unsuccessImg, alt: "Error" }),
    React.createElement("p", null, message)));
